import { ORDER_PHASE } from '../constants'
export const CURRENT = "current"

export const FILTER_DATE = {
    TODAY: "today",
    WEEK: "week",
    MONTH: "month",
};



export const FILTER_STATUS_OPTIONS = [
    { value: CURRENT, label: "En cours" },
    { value: ORDER_PHASE.REFUND, label: "Remboursées" },
    { value: ORDER_PHASE.CANCELED, label: "Annulées" },
    { value: ORDER_PHASE.COMPLETED, label: "Terminées" },

];

export const FILTER_DATE_OPTIONS = [
    { label: "Toutes les dates", value: "" },
    { value: FILTER_DATE.WEEK, label: "7 derniers jours" },
    { value: FILTER_DATE.MONTH, label: "30 derniers jours" }
];